import { IconButton } from '@chakra-ui/react'

export default IconButton
